import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  Autocomplete,
  TextField,
  Typography,
  Box,
  Chip
} from '@mui/material';
import { Restaurant, Kitchen, RestaurantMenu } from '@mui/icons-material';
import useGlobalSearch from '../../hooks/useGlobalSearch';

const GlobalSearch = ({ open, onClose, onResultSelect }) => {
  const { searchQuery, setSearchQuery, searchResults } = useGlobalSearch();
  const [inputRef, setInputRef] = useState(null);
  
  // Focus input when dialog opens
  useEffect(() => {
    if (open) {
      setSearchQuery('');
      // Add a small delay to ensure the dialog is fully rendered
      setTimeout(() => {
        if (inputRef) {
          inputRef.focus();
        }
      }, 100);
    }
  }, [open, inputRef]);
  
  const handleResultSelect = (event, value) => {
    if (value) {
      onResultSelect(value);
      onClose();
    }
  };

  // Function to get the appropriate icon
  const getIcon = (type) => {
    switch (type) {
      case "dish":
        return <Restaurant />;
      case "ingredient":
        return <Kitchen />;
      case "restaurant":
        return <RestaurantMenu />;
      default:
        return <Kitchen />;
    }
  };
  
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm" 
      fullWidth
      PaperProps={{ sx: { mt: 10 } }}
    >
      <DialogContent>
        <Autocomplete
          options={searchResults}
          getOptionLabel={(option) => option.label}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Search dishes, ingredients and restaurants... (Cmd+K)"
              autoFocus
              fullWidth
              inputRef={(ref) => setInputRef(ref)}
              onFocus={(e) => e.target.select()}
            />
          )}
          renderOption={(props, option) => (
            <Box component="li" {...props}>
              {getIcon(option.type)}
              <Box sx={{ ml: 1 }}>
                <Typography>{option.label}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {option.subtitle}
                </Typography>
              </Box>
              <Chip 
                label={option.type} 
                size="small" 
                sx={{ ml: 'auto' }}
              />
            </Box>
          )}
          onChange={handleResultSelect}
          onInputChange={(event, value) => setSearchQuery(value)}
          noOptionsText="No dishes or ingredients found"
        />
      </DialogContent>
    </Dialog>
  );
};

export default GlobalSearch;